import { Dialog } from "@headlessui/react";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
export default function UserInfoLookUpDialog({
  showDialog,
  setShowDialog,
  data,
  impersonate,
  policyNumber,
}) {
  return (
    <Dialog
      open={showDialog}
      onClose={() => {
        setShowDialog(false);
      }}
      className="ui-dialogs"
    >
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <DialogBackdrop />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className={`ui-default-dialog ${
            data.length > 5 ? "bottom-[30%]" : ""
          }`}
        >
          <Dialog.Title className="font-body text-xl font-bold text-left">
            {`Policy #${policyNumber}`}
          </Dialog.Title>
          <button
            className="ui-default-dialog-close"
            aria-label="close manage notification preferences window"
            onClick={() => {
              setShowDialog(false);
            }}
          >
            <svg
              className="ui-icon h-3.5 w-3.5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>
          <hr />
          {data.length > 0 &&
            data.map((user, index) => {
              return (
                <div
                  className="ui-card-bar relative mt-6 mb-6"
                  key={`links - ${index}`}
                >
                  <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-4">
                    <div className="px-6 py-6 lg:p-4">
                      <div className="text-xs text-theme-text-tertiary">
                        First Name
                      </div>
                      <div className="text-sm font-semibold text-theme-text-secondary">
                        {user?.firstName}
                      </div>
                    </div>
                    <div className="px-6 py-6 lg:p-4">
                      <div className="text-xs text-theme-text-tertiary">
                        Last Lame
                      </div>
                      <div className="text-sm font-semibold text-theme-text-secondary">
                        {user?.lastName}
                      </div>
                    </div>
                    <div className="px-6 py-6 lg:p-4">
                      <div className="text-xs text-theme-text-tertiary">
                        Username
                      </div>
                      <div className="text-sm font-semibold text-theme-text-secondary">
                        {user?.userName}
                      </div>
                    </div>
                    <div className="px-6 py-6 lg:p-4">
                      {/* <div className="flex flex-row-reverse justify-between sm:flex-col sm:justify-end"> */}
                      <div className="grid grid-cols-2 gap-x-4 sm:grid-cols-1 sm:gap-2">
                        <div className="col-start-2 row-start-1 place-self-end sm:col-auto sm:row-auto">
                          <button
                            className="ui-btn-primary font-semibold"
                            onClick={() => {
                              impersonate(user);
                              setShowDialog(false);
                            }}
                          >
                            select
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
